/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_FEE: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.getFee',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_FEE' },
      },
    },
    GET_FEE: {
      invoke: {
        id: 'getFee',
        src: 'getFee',
        onDone: {
          target: 'GET_FEE_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'GET_FEE_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    GET_FEE_SUCCESS: {
      on: {
        TRIGGER_REFRESH: { target: 'GET_FEE' },
      },
    },
    GET_FEE_FAILED: {
      on: {
        TRIGGER_REFRESH: { target: 'GET_FEE' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
